import { render, staticRenderFns } from "./communityDashboard.vue?vue&type=template&id=27b9685c&scoped=true"
import script from "./communityDashboard.vue?vue&type=script&lang=js"
export * from "./communityDashboard.vue?vue&type=script&lang=js"
import style0 from "./communityDashboard.vue?vue&type=style&index=0&id=27b9685c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b9685c",
  null
  
)

export default component.exports